if ("NodeList" in window && !NodeList.prototype.forEach) {
	console.info("polyfill for IE11");
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll("p") || [];
	paragraph.forEach(
		(e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
	);
	
	if (document.body.classList.contains("portfolio")) {
		
		portfolioFunctionality();
	}

	
	$(".sym-slides").slick({
		accessibility: false,
	});

	$(".slider-home").slick({
		arrows: false,
		dots: false,
		autoplay: true,
		fade: true,
		autoplaySpeed: 4000,
		speed: 1000,
	})
	$(".slider-default").slick({
		arrows: false,
		dots: false,
		autoplay: true,
		fade: true,
		autoplaySpeed: 4000,
		speed: 1000,
	});
	$(".slider").slick({
		arrows: true,
		dots: false,
		autoplay: true,
		fade: true,
		autoplaySpeed: 4000,
		speed: 1000,
		appendArrows: '.slider__arrows'
	});

	$(".full-slider-block__image").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		fade: true,
		asNavFor: ".full-slider-block__nav",
		dots: true,
		arrows: false,
		appendDots: '.full-slider-block__dots',
		customPaging: function (slider, i) {
			var title = $(slider.$slides[i]).data('title');
			var posX = $(slider.$slides[i]).data('x');
			var posY = $(slider.$slides[i]).data('y');
			return '<div class="pin" style="position: absolute; right:' + posX + 'px; top: '+ posY +'px;"><span class="dots__item">' + title + ' </span></div>';
		},
		responsive: [
			{
				breakpoint: 600,
				settings: {
					// slidesToScroll: 10,
					variableWidth: true,
				}
			}
		]
	});
	$(".full-slider-block__nav").slick({
		slidesToShow: 1,
		arrows: true,
		speed: 1000,
		fade: true,
		asNavFor: ".full-slider-block__image",
		slidesToScroll: 1,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					appendArrows: '.full-slider-block__arrows',
					adaptiveHeight: true
				}
			}
		]
	});
	$(".portfolio__container").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplaySpeed: 2000
	})
	$(".three-columns__container").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		fade: true,
		appendArrows: '.three-columns__arrows',
		mobileFirst: true,
		accessibility: false,
		responsive: [
			{
				breakpoint: 767,
				settings: 'unslick',
				accessibility: true,
			}
		]

	})
	// $('.stories-block').imagesLoaded(function () {
	// 	$('.stories__container').masonry({
	// 		itemSelector: '.stories__image',
	// 		// horizontalOrder: true,
	// 		// gutter: 15,
	// 		// percentPosition: true,
	// 	});
	// });
})();

function loginMembers(e){
	e.preventDefault();
	var extras = new Object(),formId = "loginForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'loginMembers',
		username: $("#username").val(),
		password: $("#password").val()
	},
	function(data){
		if(data.result == 'success') {
			localStorage.setItem( "username", data.name );

			extras.page_redirect = '/employee/employee-rates';
			document.location = "/employee/employee-rates";
			if(data.warning==1)
				localStorage.setItem('msg',1);
			//showResult(data, formId, extras);
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function showResult(data, formId, extras)
{
	/*extras parameters:
		dont_reset_form = if set will not reset the form
		dont_hide_form = if set will not hide the form
		skip_parent_errors = if set errors will not be placed on the parent elements
		step_content = if set will load up the content  into div
		page_redirect = if set will redirect to the page passed on success
		function_name = if set will call function on form submit success
		use_exact_path = if set will use exact path passed instead of a SITE_ROOT path
		exact_path = path to use for the above option
		dont_scroll_on_error = if set will not scroll to top of page when theres an error
		dont_scroll_on_success = if set will not scroll to top on success
		scrollto = element id to scroll to instead
		clear_errors = if set will clear errors on the form
		dont_hide_buttons = if set will not hide the buttons, use for nested forms.
	*/
	if(extras == undefined) { extras = '' } //check if the extras parameters array exists if not set it so that we dont get errors farther down

	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

	if(extras.dont_hide_buttons != '1')
	{
    	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  		if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
  	}

  	//check if result is being passed the new way
	var result; //will hold the value for our result success | error

	if(data[0]==undefined) result = data.result;
	else result = data[0].result;

  	if(result=="success")
	{
  		if(extras.dont_reset_form != '1') { resetForm(formId); } //if the dont_reset_form is isnt set then reset the form
		if(extras.step_content != undefined) //check if the ajax page parameter is defined
		{
			//alert('load up via ajax: ' + data[1].step_content);
		   	$("#step_content").hide();	//this has to stay the same because this is where the forms are being loaded into
	   		$("#step_content").load(SITE_ROOT+extras.step_content,function(){
	   			_gaq.push(['_trackPageview', extras.step_content]);

	        	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	        	$("#step_content").slideDown();}
	        );
	   		if(extras.dont_scroll_on_success != '1')
	        {
		   		if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
	        }
		}
		else if(extras.page_redirect != undefined) //check if page redirect parameter is passed
		{
			if(extras.use_exact_path =='1')
			{
				document.location = extras.exact_path;
			}
			else
			{
				document.location= extras.page_redirect;
			}
		}
		else if(extras.function_name != undefined)
		{
			eval(extras.function_name)();
		}
		else
		{
			if($('.thankyouMsg').length > 0) $('#'+formId+' .thankyouMsg').slideDown();
			if($('#'+formId).prev(".thankyouMsg").length > 0) $('#'+formId).prev(".thankyouMsg").slideDown();

			if(extras.dont_hide_form != '1')
			{
				if($('#'+formId).length > 0) $("#"+formId).slideUp();
			}
			else
			{
				if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
			}
			if(extras.dont_scroll_on_success != '1')
	        {
				if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
			}
		}
		if(extras.clear_errors == '1')
		{ 	clearErrors(formId);	}
	}
	else
	{
		showErrors(data,formId,extras);
	}
}

function showErrors(data,formId,extras){
	clearErrors(formId);

	var newData = new Object();
	if(data[0]==undefined) newData = data;
	else newData = data[0];
	//loop through the JSON array and display the errors
	$.each(newData, function(key,value) {
		if(key != "result")
		{
			if(extras.add_parent_error != undefined)
			{
				if($('#'+key).parent().hasClass("form-entry")) $('#'+key).parent().addClass("error");
			}
			$('label[for='+key+']').addClass("error");
			$('#'+key).addClass("error");
			if(value!=1) { $("#"+formId+" .errorMsg").html($("#"+formId+" .errorMsg").html()+"<li>"+value+"</li>"); }
		}
	});
	if($("#"+formId+" .errorMsg").html()=="") {
		$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red below</li></ul>");
	} else {
		$("#"+formId+" .errorMsg").html("<ul>"+$("#"+formId+" .errorMsg").html()+"</ul>");
	}
	$("#"+formId+" .errorMsg").slideDown();

	if(extras.dont_scroll_on_error != '1')
	{
		if(extras.scrollto != undefined)
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
        	} else {
        		//$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
        	}
   		}
   		else
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo(0,100);
        	} else {
        		//$.scrollTo(0,800);
        	}
   		}
	}

	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').show();
}


function clearErrors(formId)  //safari bug is here!!
{
	$('input[type="text"],input[type="password"],input[type="radio"],textarea,select').removeClass("error");
	$('#'+formId+' label').each(function(index){
        if(!$(this).hasClass('errorMsg')) $(this).removeClass("error");
    });
}

function resetForm(formId)
{
	//$('[type="text"]').val("");
	$('#'+formId+' textarea').val("");
	$(':input','#'+formId)
	 .not(':button, :submit, :reset, :hidden, :checkbox , :radio')
	 .val('')
	 .removeAttr('checked')
	 .removeAttr('selected');

	clearErrors(formId);
}
function formProcessSetup(formId)
{
	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

    if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
}

function portfolioFunctionality() {
		let portfolioFilters = document.querySelectorAll('.portfolio-filter__item');
    let portfolioViews = document.querySelectorAll('.grid-block');
		portfolioViews[0].classList.add('grid-show');
		portfolioViews[0].classList.remove('grid-hide');
    portfolioFilters.forEach(button => {
		console.log('Mobile click');
        button.addEventListener('click', () => {
			portfolioFilters.forEach(item => {
				item.classList.remove('active');
			});
			button.classList.add('active');
			portfolioViews.forEach(view => {
				view.classList.remove('grid-show');
				view.classList.add('grid-hide');
			});
			portfolioViews.forEach(view => {
				if(button.dataset.tab == view.dataset.tab) {
					view.classList.add('grid-show');
					view.classList.remove('grid-hide');
				}
			})
        })
    })
}